<template>

    <div>


        <div id="app" :class="{ 'bloc-scroll': maintenance }">

            <header-left>

                <router-view class="app"/>

            </header-left>

            <maintenance :maintenance="maintenance"></maintenance>

            <modal-cookies-policy ref="mcp"></modal-cookies-policy>

            <cookie-law @manage="openCookieLaw"></cookie-law>

        </div>

        <metas></metas>

        <structured-data></structured-data>

        <check-offline></check-offline>

        <optimize-trigger></optimize-trigger>

    </div>

</template>

<script>

import Vuex from 'vuex'

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import CheckOffline from '@/components/CheckOffline'
import CookieLaw from '@/components/CookieLaw'
import HeaderLeft from '@/components/headers/HeaderLeft'
import Maintenance from '@/components/Maintenance'
import Metas from '@/components/Metas'
import ModalCookiesPolicy from '@/components/modal/ModalCookiesPolicy'
import OptimizeTrigger from '@/components/OptimizeTrigger'
import StructuredData from '@/components/StructuredData.vue'

export default {

    components: {CheckOffline, CookieLaw, HeaderLeft, Maintenance, Metas, ModalCookiesPolicy, OptimizeTrigger, StructuredData},

    computed: {

        ...Vuex.mapGetters(['maintenance'])

    },

    created() {

        I18n.created(this)

        const regexNative = new RegExp('^/fox/native/')
        if(!regexNative.test(this.$route.path)) {
            Tag.initTracking(this)
        }

        try {
            document.getElementById('app-speed-index').remove()
        } catch (ignored) {
            // do nothing
        }

    },

    mounted() {

        window.scrollTo(0, 1)

    },

    methods: {

        openCookieLaw() {

            this.$refs.mcp.open()
        }
    }
}

</script>

<style lang="scss" src="./style/main.scss"></style>

<style lang="scss" scoped>

.app {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.bloc-scroll {
    height: 100vh;
    overflow: hidden;
}

</style>

